import axios from "axios";

const api = axios.create({
  baseURL: "https://haaterkaj-backend-1.onrender.com", // your backend server URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
